import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { useAuth } from "./contexts/AuthContext";
import Layout from "./components/Layout";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Incidents from "./pages/Incidents";
import IncidentDetail from "./pages/IncidentDetail";
import ServiceRequests from "./pages/ServiceRequests";
import ServiceRequestDetail from "./pages/ServiceRequestDetail";
import ChangeRequests from "./pages/ChangeRequests";
import ChangeRequestDetail from "./pages/ChangeRequestDetail";
import Problems from "./pages/Problems";
import ProblemDetail from "./pages/ProblemDetail";
import OverdueWork from "./pages/OverdueWork";
import AdminPanel from "./pages/AdminPanel";
import KnowledgeBase from "./pages/KnowledgeBase";
import KnowledgeBaseDetail from "./pages/KnowledgeBaseDetail";
import KnowledgeBaseEdit from "./pages/KnowledgeBaseEdit";
import CABCalendar from "./pages/CABCalendar";
import Reports from "./pages/Reports";

function Private({ roles, children }) {
  const { user, hasRole } = useAuth();
  if (!user) return <Navigate to="/" replace />;
  if (roles && !hasRole(...roles)) return <Navigate to="/" replace />;
  return children;
}

export default function App() {
  const { user } = useAuth();
  return (
    <Routes>
      {!user && <Route path="*" element={<Login />} />}
      {user && (
        <Route element={<Layout />}>
          <Route path="/" element={<Dashboard />} />
          <Route path="/incidents" element={<Incidents />} />
          <Route path="/incidents/:id" element={<IncidentDetail />} />
          <Route path="/service-requests" element={<ServiceRequests />} />
          <Route path="/service-requests/:id" element={<ServiceRequestDetail />} />
          <Route path="/change-requests" element={<ChangeRequests />} />
          <Route path="/change-requests/:id" element={<ChangeRequestDetail />} />
          <Route path="/problems" element={<Problems />} />
          <Route path="/problems/:id" element={<ProblemDetail />} />
          <Route path="/overdue" element={
            <Private roles={["admin", "it_manager"]}><OverdueWork /></Private>
          } />
          <Route path="/reports" element={
            <Private roles={["admin", "it_manager"]}><Reports /></Private>
          } />
          <Route path="/cab-calendar" element={<CABCalendar />} />
          <Route path="/knowledge-base" element={<KnowledgeBase />} />
          <Route path="/knowledge-base/new" element={
            <Private roles={["admin", "it_team", "it_manager", "it_security"]}><KnowledgeBaseEdit /></Private>
          } />
          <Route path="/knowledge-base/:id/edit" element={
            <Private roles={["admin", "it_team", "it_manager", "it_security"]}><KnowledgeBaseEdit /></Private>
          } />
          <Route path="/knowledge-base/:id" element={<KnowledgeBaseDetail />} />
          <Route path="/admin" element={
            <Private roles={["admin"]}><AdminPanel /></Private>
          } />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
      )}
    </Routes>
  );
}
